import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BlogIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Blog",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.91 4.23H9.46a3.05 3.05 0 0 0-3.05 3.05V24.3c0 .49-.4.89-.89.89s-.89-.4-.89-.89V11.65c-.06-.68-.62-1.2-1.31-1.2s-1.25.53-1.31 1.2v12.66c0 1.85 1.45 3.36 3.28 3.46h19.92c2.65 0 4.8-2.15 4.8-4.8V7.29a3.05 3.05 0 0 0-3.05-3.05h-.04Zm.44 18.75c0 1.2-.98 2.17-2.18 2.18H9.02V7.3c0-.24.2-.44.44-.44h17.46c.24 0 .44.2.44.44v15.68ZM12.08 8.6h12.21c.73 0 1.31.59 1.31 1.31v3.48c0 .73-.59 1.31-1.31 1.31H12.08c-.73 0-1.31-.59-1.31-1.31V9.91c0-.72.59-1.31 1.31-1.31m12.21 7.85H12.08c-.68.06-1.2.62-1.2 1.31s.53 1.25 1.2 1.31h12.33c.73 0 1.31-.59 1.31-1.31s-.59-1.31-1.31-1.31h-.11Zm0 4.37H11.97c-.73 0-1.31.59-1.31 1.31s.59 1.31 1.31 1.31H24.4c.73 0 1.31-.59 1.31-1.31s-.59-1.31-1.31-1.31z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.29 29H9.58c-3.15 0-5.71-2.56-5.71-5.71v-9.14a1.14 1.14 0 1 1 2.28 0v9.14c0 1.89 1.54 3.43 3.43 3.43h13.71c1.89 0 3.43-1.54 3.43-3.43v-16c0-.63-.51-1.14-1.14-1.14H11.87c-.63 0-1.14.51-1.14 1.14v16a1.14 1.14 0 1 1-2.28 0v-16c0-1.89 1.54-3.43 3.43-3.43h13.71c1.89 0 3.43 1.54 3.43 3.43v16c0 3.15-2.56 5.71-5.71 5.71Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.29 15.29h-9.14c-.63 0-1.14-.51-1.14-1.14V9.58c0-.63.51-1.14 1.14-1.14h9.14c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14m-8-2.29h6.86v-2.29h-6.86zM23.29 19.86h-9.14a1.14 1.14 0 1 1 0-2.28h9.14a1.14 1.14 0 1 1 0 2.28M19.86 24.43h-5.71a1.14 1.14 0 1 1 0-2.28h5.71a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};